import { API_URL } from '../../utils/constants';

import request from '../request';
import { ReportRequestDto } from '~/src/types/ReportRequestDto';

export default {
  startExport: async (id: string, type: string) => {
    return request(`${API_URL}/inventory-export/start-export/${id}/${type}`, 'post');
  },

  checkAndDownloadExport: async (id: string) => {
    return request(`${API_URL}/inventory-export/check-ready-export/${id}`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },
}